
export {ClayButtonWithIcon} from '@clayui/button';
import __x__ from '@clayui/button';export default __x__;